import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "truncate"
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, number: number): string {
    const regexp = new RegExp("(([^\\s]+\\s\\s*){" + number + "})([\\S\\s]*)", "g")
    return value.replace(regexp, "$1...");
  }
}
